<script setup lang="ts">
import type { SeoBaseProps } from "~/components/seo/Base.props"
import { customPaths } from "~/utils/constants"
import consola from "consola"

const route = useRoute()
const { locale } = useI18n()

const requestId = route.path + "_" + Date.now()

import.meta.server &&
  consola.info(
    new Date().toISOString(),
    "Sub-brand page rendering start",
    route.path,
    requestId
  )

import.meta.server &&
  consola.info(
    new Date().toISOString(),
    "Sub-brand page Gluon start",
    route.path,
    requestId
  )

const { data: pageData, error } = await usePage(
  `/api/gluon-ext/fetchProductBrandSubListingPage/${locale.value}/${route.params.brand}/${route.params.slug}/brand_sublisting.js`
)

import.meta.server &&
  consola.info(
    new Date().toISOString(),
    "Sub-brand page Gluon end",
    route.path,
    requestId
  )

if (error.value) {
  if (useRuntimeConfig().seo?.redirectMissingBrandToBrandHome) {
    await navigateTo(customPaths.brands, {
      redirectCode: 302
    })
  } else {
    import.meta.server &&
      consola.error(
        new Date().toISOString(),
        "Sub-brand page error",
        "Error loading Gluon data",
        route.path,
        requestId,
        error.value
      )
    throw createError({
      message: error.value.message,
      statusCode: error.value.statusCode ?? 404
    })
  }
}

const loadPage = ref(
  isNaN(parseInt(route.query.page as string))
    ? 0
    : parseInt(route.query.page as string) - 1
)

const seoData = computed((): SeoBaseProps => {
  return {
    ...pageData.value?.seo,
    metaTitle:
      `${pageData.value?.seo.metaTitle} - Pagina ${route.params.page}` ??
      `${pageData.value?.pageInfo.mainTitle} - Pagina ${route.params.page}` ??
      undefined,
    metaDescription:
      `${pageData.value?.seo.metaDescription} - Pagina ${route.params.page}` ??
      undefined
  }
})
</script>

<template>
  <div class="brand-category-page">
    <SeoBase v-bind="seoData" />
    <PagesBrandSubListing
      v-if="pageData"
      :page-info="pageData.pageInfo"
      :breadcrumbs="pageData.breadcrumbs"
      :load-page="loadPage"
      :seo="pageData.seo"
      :content="pageData.content"
    />
  </div>
</template>
